// Sidebar entries owned by the Settings module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { paths } from '@/utils/path'
import { settingsPaths } from './paths'

export const settingsNav = {
    serviceTemplates: {
        title: 'settings:sidebar_service_templates',
        path: settingsPaths.serviceTemplates,
        ignorePermission: true,
    },
    slaTemplates: {
        title: 'settings:sidebar_sla_templates',
        // Service owns the SLA template pages (and their path keys).
        path: paths.slaTemplates,
        ignorePermission: true,
    },
    regulations: {
        title: 'settings:sidebar_regulations',
        path: settingsPaths.regulations,
        // Authenticated read access, matching the Regulation API.
    },
    productService: {
        title: 'settings:sidebar_product_service',
        path: settingsPaths.productServiceManagement,
        ignorePermission: true,
    },
    // authorization: {
    //     title: 'settings:sidebar_authorization',
    //     path: settingsPaths.authorization,
    //     ignorePermission: true,
    // },
    dataAccess: {
        title: 'settings:sidebar_data_access',
        path: settingsPaths.dataAccess,
        require_admin: true,
    },
} satisfies Record<string, SidebarType>
